import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const generalService = inject(GeneralService);
  const tokenService = inject(TokenService);

  if (generalService.isBrowserOnly) {
    if (!tokenService.getRtk()) {
      return true;
    }
  }
  generalService.router.navigateByUrl('/');
  return false;
};
